import React from "react";
import {registerBlockType} from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import {RichText} from "@wordpress/block-editor";
import {PanelBody,Panel,RangeControl,SelectControl,CheckboxControl,TextControl,Button} from "@wordpress/components";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    MediaUpload,
    MediaUploadCheck,
    __experimentalLinkControl as LinkControl
} from '@wordpress/block-editor';
import IconSelect from "./IconSelect";
import PMGColorPalette from "./PMGColorPalette";

registerBlockType("template-scripts/tabbed-content",{
  "title":"Tabbed Content",
  "category":"template-scripts",
  "icon":"button",
  attributes:{
    maxWidth:{type:'number',default:1600},
    contentWidth:{type:'number',default:500},
    textAlign:{type:'string',default:'left'},
    buttonColor:{type:'string',default:'teal'},
    slideDetails:{type:'array',default:[{
      title:"",
      subTitle:"",
      content:"",
    }]}

  },

  edit:function({attributes,setAttributes}){
    const sliderContainer = React.useRef();
    const sliderRef = React.useRef();
    const [slideIndex,setSlideIndex] = React.useState(0);

    
    React.useEffect(()=>{
      if(!sliderContainer.current) return;
      if(!window.tabbedContent) return;
      sliderRef.current = new window.tabbedContent(sliderContainer.current);
      sliderRef.current.onChange = (index) => {
        setSlideIndex(index);
      }

    },[]);

    

    React.useEffect(()=>{
      if(!sliderRef.current) return;
      sliderRef.current.load();
    },[attributes.slideDetails.length]);
   
    const updateSlide = (index,key,value) => {
      const newSlideDetails = attributes.slideDetails;
      if(!newSlideDetails[index]){
        newSlideDetails[index] = {};
      }
      newSlideDetails[index][key] = value;
      setAttributes({
        slideDetails:[...newSlideDetails]
      });
    }

    const addSlide = () => {
      setAttributes({
        slideDetails:[...attributes.slideDetails,{
          title:"",
          content:"",
        }]
      });
    }

    const deleteSlide = (index) => {
      var newSlides = attributes.slideDetails;
      newSlides.splice(index,1);
      setAttributes({
        slideDetails:[...newSlides]
      });

    }





    const contentComponents = attributes.slideDetails.map((s,i)=>{
      var contentMargin = "0px";
      if(attributes.textAlign === "center"){
        contentMargin = "0px auto";
      }
      if(attributes.textAlign === "right"){
        contentMargin = "0px 0px 0px auto";
      }
      return (<div className="content" key={`slideContent${i}`}>
          <RichText tagName="div" placeholder="Tab content goes here" value={s.content} onChange={(v)=>updateSlide(i,"content",v)} style={{maxWidth:attributes.contentWidth+"px",margin:contentMargin}}/>
            {s.showButton ? (<div className="btn" style={{margin:contentMargin,marginTop:"20px",color:"#fff",backgroundColor:attributes.buttonColor}}>

              <RichText tagName="div" placeholder="Button Text" className={`btn-${attributes.buttonColor}`} value={s.buttonText} onChange={(v)=>updateSlide(i,"buttonText",v)}/>
            </div>) : (<></>)}
      </div>);
    });

    const tabComponents = attributes.slideDetails.map((s,i)=>{
      return (<div className="tab" key={`tab${i}`}>
          <RichText tagName="h2" value={s.title} placeholder="Tab Title" onChange={(v)=>updateSlide(i,"title",v)}/>
          <RichText tagName="h3" value={s.subTitle} placeholder="Tab SubTitle" onChange={(v)=>updateSlide(i,"subTitle",v)}/>
          <Button isDestructive onClick={()=>deleteSlide(i)} style={{position:"absolute",right:"0px",top:"0px"}}>&times;</Button>
      </div>);
    });

    
    return (<div>
      <InspectorControls>
        <Panel>
          <PanelBody title="Layout">
            <RangeControl
              label="Max Width"
              value={attributes.maxWidth}
              onChange={(v)=>setAttributes({maxWidth:v})}
              min={100}
              max={1600}
              step={1}
            />
            <RangeControl
              label="Content Width"
              value={attributes.contentWidth}
              onChange={(v)=>setAttributes({contentWidth:v})}
              min={100}
              max={1600}
              step={1}
            />
            <SelectControl
              label="Text Align"
              value={attributes.textAlign}
              onChange={(v)=>setAttributes({textAlign:v})}
              options={[
                {label:"Left",value:"left"},
                {label:"Center",value:"center"},
                {label:"Right",value:"right"}
              ]}
            />

          </PanelBody>
          <PanelBody title={`${attributes.slideDetails[slideIndex]?.title} Slide Options`}>
            <CheckboxControl
              checked={attributes.slideDetails[slideIndex]?.showButton || false}
              onChange={(v)=>updateSlide(slideIndex,"showButton",v)}
              label="Show CTA Button"
            />
            {attributes.slideDetails[slideIndex]?.showButton ? (<>
              <TextControl
                label="Button Text"
                value={attributes.slideDetails[slideIndex]?.buttonText}
                onChange={(v)=>updateSlide(slideIndex,"buttonText",v)}
              />
              <LinkControl
                label="Button Link"
                value={attributes.slideDetails[slideIndex]?.buttonLink}
                onChange={(v)=>updateSlide(slideIndex,"buttonLink",v)}
              />
            </>) : (<></>)}
          </PanelBody>
        </Panel>
      </InspectorControls>
      <BlockControls/>
      <div className="tabbedContent editor" ref={sliderContainer} style={{width:attributes.maxWidth+"px"}}>
        <div className="tabHolder">
          {tabComponents}
          <div style={{display:"block",paddingBottom:"10px",textAlign:"center"}}><Button variant={`primary`} onClick={addSlide}>Add New Tab</Button></div>
        </div>
        <div className="contentHolder" style={{textAlign:attributes.textAlign}}>
          {contentComponents}
        </div>
      </div>
      
    </div>);
  },
  save:function({attributes}){

    const contentComponents = attributes.slideDetails.map((s,i)=>{
      var contentMargin = "0px";
      if(attributes.textAlign === "center"){
        contentMargin = "0px auto";
      }
      if(attributes.textAlign === "right"){
        contentMargin = "0px 0px 0px auto";
      }
      return (<div className="content" key={`slideContent${i}`} style={{textAlign:attributes.textAlign}}>
          <RichText.Content tagName="div" value={s.content} style={{maxWidth:attributes.contentWidth+"px",margin:contentMargin}}/>
          {s.showButton ? (<>
              <a href={s.buttonLink?.url} className="btn" target={s.buttonLink?.target} style={{margin:contentMargin,marginTop:"20px",color:"#fff",backgroundColor:attributes.buttonColor}}>
                <RichText.Content tagName="div" value={s.buttonText}/></a>
            </>) : (<></>)}
      </div>);
    });

    const tabComponents = attributes.slideDetails.map((s,i)=>{
      return (<div className="tab" key={`tab${i}`}>
          <RichText.Content tagName="h2" value={s.title}/>
          <RichText.Content tagName="h3" value={s.subTitle}/>
      </div>);
    });


    return (<div className="tabbedContent" style={{width:attributes.maxWidth+"px"}}>
      <div className="tabHolder">
        {tabComponents}
      </div>
      <div className="contentHolder">
        {contentComponents}
      </div>
    </div>);
  }
});

